import React from 'react';
import SplashVideo from '../Assets/Desktop.webm';
import XtractorText from '../Assets/XtractorLogo.svg';
import './style.css';

function SplashScreen() {
  return (
    <div class="container-fluid p-0 m-0" style={{height: '100vh', width: '100vw',overflow: 'hidden'}}>
    <section id="splash-screen">
        <video className="VideoTag" autoPlay loop muted>
            <source src={SplashVideo} type="video/webm" />
        </video>
        <img src={XtractorText} style={{position: 'absolute',top: '40%', left: '43%',marginLeft: 'auto', marginRight: 'auto'}} />
    </section>
    </div>
  )
}

export default SplashScreen;
